// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"98":"5fe9dc19","109":"4e6e257d","326":"e72eb95e","783":"d1477437","862":"752db0ed"}[chunkId] + ".chunk.js";
};